import { IResourceDetail, ResourceListServant } from 'capability-ng-resources';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';

interface IPlaceDetailStateParams extends ng.ui.IStateParamsService {
  relationship: string;
  contactId: string;
}

export class MyPlaceDetailViewController {
  private resource: IResourceDetail;

  constructor(
    private ngResourceListServant: ResourceListServant,
    private $stateParams: IPlaceDetailStateParams,
    private unfavoriteResourceCommand: ICommand,
    private favoriteResourceCommand: ICommand,
    private log: any,
    private loadResourcesCommand: ICommand,
    private loadResourceCategoriesCommand: ICommand
  ) {
    this._getResourse();
  }

  _getResourse() {
    this.resource = this.ngResourceListServant.getResource(this.$stateParams.id);
  }

  toggleFavorite(): void {
    this.resource.favorite_id
      ? this.unfavoriteResourceCommand(this.resource)
          .then((res) => _.assign(this.resource, res))
          .catch(() => this.log.user.error("Looks like I couldn't unfavorite that."))
      : this.favoriteResourceCommand(this.resource)
          .then((res) => _.assign(this.resource, res))
          .catch(() => this.log.user.error("Looks like I couldn't favorite that."));
  }
}



// WEBPACK FOOTER //
// ./app/lib/my_resources/views/my_place_detail/my_place_detail_controller.ts